const BASE_URL = 'http://54.174.176.45:8000/';
export {BASE_URL};